import { render, staticRenderFns } from "./SimilarSupplier.vue?vue&type=template&id=1c6b643f&scoped=true&"
import script from "./SimilarSupplier.vue?vue&type=script&lang=js&"
export * from "./SimilarSupplier.vue?vue&type=script&lang=js&"
import style0 from "./SimilarSupplier.vue?vue&type=style&index=0&id=1c6b643f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6b643f",
  null
  
)

export default component.exports